import axios from 'axios';
import BASEURL from '../BaseUrl';
import { logoutApi } from './AuthApi';

export const createEntity = async (engagementId, data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/data-model/entity/${engagementId}`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const dataModelLoadData = async (payload) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/data-model/run/${payload.entityId}`, payload, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const dataModelExecutionList = async (entityId) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    const response = await axios.get(`${BASEURL}/data-model/execution-list`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { entityId },
    });
    return response.data; // ✅ should be an array
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getDataModelsList = async () => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    const response = await axios.get(`${BASEURL}/data-model/get-data-models`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
    return response;
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const dataModelExecutionDetailsById = async (executionId) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/data-model/execution-by-id`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { executionId },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getAllEntitiesByEngagementId = async (engagementId) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/data-model/entities/${engagementId}`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getEntityDetailsByEntityId = async (engagementId, entityId) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/data-model/by-engagement/${engagementId}?entityId=${entityId}`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getAllBuiltInRules = async () => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    const res = await axios.get(`${BASEURL}/data-model/builtin-rules`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
    return res.data;
  } catch (error) {
    if (error.response?.status === 401) await logoutApi();
    throw error;
  }
};

export const getBuiltInRuleById = async (ruleId, entityId) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    const res = await axios.get(`${BASEURL}/data-model/builtin-rules/${ruleId}`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { entityId },
    });
    return res.data;
  } catch (error) {
    if (error.response?.status === 401) await logoutApi();
    throw error;
  }
};

export const addCleanseRuleByEntityId = async (entityId, data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    const res = await axios.post(`${BASEURL}/data-model/add-cleanse-rules/${entityId}`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
    return res.data;
  } catch (error) {
    if (error.response?.status === 401) await logoutApi();
    throw error;
  }
};

export const getCleanseRulesByEntityId = async (entityId) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    const res = await axios.get(`${BASEURL}/data-model/cleanse-rules/${entityId}`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
    return res.data;
  } catch (error) {
    if (error.response?.status === 401) await logoutApi();
    throw error;
  }
};

export const getOverAllCleanseRules = async () => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    const res = await axios.get(`${BASEURL}/data-model/get-cleanse-rule-list`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
    return res.data;
  } catch (error) {
    if (error.response?.status === 401) await logoutApi();
    throw error;
  }
};

export const createCopyCleanseRule = async (data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/data-model/add-existing-cleanse-rule`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const addAttributesByEntityId = async (entityId, data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    const res = await axios.patch(`${BASEURL}/data-model/attributes/${entityId}`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
    return res.data;
  } catch (error) {
    if (error.response?.status === 401) await logoutApi();
    throw error;
  }
};

export const editAttributesByEntityId = async (entityId, attributeName, data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    const res = await axios.put(`${BASEURL}/data-model/attributes/${entityId}/${attributeName}`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
    return res;
  } catch (error) {
    if (error.response?.status === 401) await logoutApi();
    throw error;
  }
};

export const addMatchRuleByEntityId = async (entityId, data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    const res = await axios.post(`${BASEURL}/data-model/add-match-rules/${entityId}`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
    return res;
  } catch (error) {
    if (error.response?.status === 401) await logoutApi();
    throw error;
  }
};

export const updateMatchRuleByEntityId = async (id, data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    const res = await axios.put(`${BASEURL}/data-model/update-match-rules/${id}`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
    return res;
  } catch (error) {
    if (error.response?.status === 401) await logoutApi();
    throw error;
  }
};

export const getMatchRuleByEntityId = async (entityId) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    const res = await axios.get(`${BASEURL}/data-model/match-rules/${entityId}`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
    return res;
  } catch (error) {
    if (error.response?.status === 401) await logoutApi();
    throw error;
  }
};

export const addSurvivorshipRuleByEntityId = async (entityId, payload) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/data-model/add-survivorship-rules/${entityId}`, payload, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response?.status === 401) await logoutApi();
    throw error;
  }
};

export const updateSurvivorshipRuleById = async (id, payload) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.put(`${BASEURL}/data-model/update-survivorship-rules/${id}`, payload, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response?.status === 401) await logoutApi();
    throw error;
  }
};

export const getSurvivorshipRulesByEntityId = async (entityId) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/data-model/survivorship-rules/${entityId}`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response?.status === 401) await logoutApi();
    throw error;
  }
};

export const getSurvivorshipRuleById = async (id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/data-model/survivorship-rules-by-id/${id}`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response?.status === 401) await logoutApi();
    throw error;
  }
};

export const updateActiveSurvivorshipStatus = async (id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.patch(
      `${BASEURL}/data-model/activate-survivorship-rules/${id}`,
      {},
      {
        headers: { Authorization: `Bearer ${parseToken}` },
      }
    );
  } catch (error) {
    if (error.response?.status === 401)
      // await logoutApi();
      throw error;
  }
};

export const updateActiveCleanseStatus = async (id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.patch(
      `${BASEURL}/data-model/activate-cleanse-rules/${id}`,
      {},
      {
        headers: { Authorization: `Bearer ${parseToken}` },
      }
    );
  } catch (error) {
    if (error.response?.status === 401)
      // await logoutApi();
      throw error;
  }
};

export const updateActiveMatchStatus = async (id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.patch(
      `${BASEURL}/data-model/activate-match-rules/${id}`,
      {},
      {
        headers: { Authorization: `Bearer ${parseToken}` },
      }
    );
  } catch (error) {
    if (error.response?.status === 401)
      // await logoutApi();
      throw error;
  }
};
